import {VariantConfigT} from '@/lib/types/colors.types';

export const pinkConfig: VariantConfigT = {
  basic: {
    icon: 'pink',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'pink',
    active: 'pink',
  },
  outline: {
    icon: 'pink',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  ghost: {
    icon: 'pink',
    iconHover: 'pink',
    iconActive: 'pink',
    hover: 'pink',
    active: 'pink',
  },
  gradient: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  solid: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
};
